export interface BonusProgress {
  position: number; // is used for UI
  title: string;
  current: number;
  total: number;
  currency?: string;
}

export interface InitialBonusStats {
  daysLeft: number;
  progress: { [statName: string]: BonusProgress };
  promoIdLegacy: number;
  pips?: number;
}

export interface BonusStats extends InitialBonusStats {
  accountId: number;
  activeDays: number;
  closedAt: string;
  createdAt: string;
  expirationDays: number;
  initialBonus: number;
  lots: number;
  minActiveDays: number;
  minLots: number;
  minProfit: number;
  profit: number;
  receiverAccount: number;
  userId: number;
  willBeClose: string;
  withdrawalAvailable: number;
  isBonusRequirementsFulfilled: boolean;
}

export const VpsStats: InitialBonusStats = {
  daysLeft: 50,
  progress: {
    lots: {
      position: 2,
      title: 'Traded lots',
      current: 0,
      total: 5.00
    }
  },
  promoIdLegacy: 0
};

